import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import request from '@/utils/request';
import { encrypt } from '@/utils/rsaEncrypt';
export function add(data) {
  return request({
    url: 'api/users',
    method: 'post',
    data: data
  });
}
export function del(ids) {
  return request({
    url: 'api/users',
    method: 'delete',
    data: ids
  });
}
export function edit(data) {
  return request({
    url: 'api/users',
    method: 'put',
    data: data
  });
}
export function editUser(data) {
  return request({
    url: 'api/users/center',
    method: 'put',
    data: data
  });
}
export function enable(data) {
  return request({
    url: 'api/users/enable',
    method: 'put',
    data: data
  });
}
export function disable(data) {
  return request({
    url: 'api/users/disable',
    method: 'put',
    data: data
  });
}

/**
 * 判断是否需要修改密码
 *
 * @return {Promise<boolean>}
 */
export function checkNeedToUpdatePass() {
  return _checkNeedToUpdatePass.apply(this, arguments);
}
function _checkNeedToUpdatePass() {
  _checkNeedToUpdatePass = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _yield$request, needToChangePassword;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return request({
            url: 'auth/needToChangePassword',
            method: 'get'
          });
        case 3:
          _yield$request = _context.sent;
          needToChangePassword = _yield$request.needToChangePassword;
          return _context.abrupt("return", !!needToChangePassword);
        case 8:
          _context.prev = 8;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", false);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 8]]);
  }));
  return _checkNeedToUpdatePass.apply(this, arguments);
}
export function updatePass(user) {
  var data = {
    oldPass: encrypt(user.oldPass),
    newPass: encrypt(user.newPass)
  };
  return request({
    url: 'api/users/updatePass',
    method: 'post',
    data: data
  });
}
export function updatePassAsync() {
  return _updatePassAsync.apply(this, arguments);
}
function _updatePassAsync() {
  _updatePassAsync = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var params,
      data,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          params = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : {};
          _context2.prev = 1;
          data = {
            oldPass: encrypt(params.oldPass),
            newPass: encrypt(params.newPass)
          };
          _context2.next = 5;
          return request({
            url: 'api/users/updatePass',
            method: 'post',
            data: data
          });
        case 5:
          return _context2.abrupt("return", true);
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](1);
          return _context2.abrupt("return", false);
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[1, 8]]);
  }));
  return _updatePassAsync.apply(this, arguments);
}
export function adminUpdatePass(data) {
  return request({
    url: 'api/users/adminUpdatePass',
    method: 'post',
    data: data
  });
}
export function updateEmail(form) {
  var data = {
    password: encrypt(form.pass),
    email: form.email
  };
  return request({
    url: 'api/users/updateEmail/' + form.code,
    method: 'post',
    data: data
  });
}
export default {
  add: add,
  edit: edit,
  del: del,
  disable: disable,
  enable: enable,
  checkNeedToUpdatePass: checkNeedToUpdatePass,
  updatePass: updatePass,
  updatePassAsync: updatePassAsync,
  adminUpdatePass: adminUpdatePass
};